/*
 * YesBankTransactoinLimits actions
 */
import * as reqHandler from '../../config/services/serviceHandler';
import endpoint from '../../config/endPoints';
import {
  clearDefaultError,
  rootApiResponse,
} from '../HeaderContainer/actions';
import {
  errorResponse,
} from '../../devUtils/commonUtils';
import {
  FETCH_CARD_DATA_YBL,
} from '../NetworkCards/constants';
import { FETCH_ONLINE_TRANSACTION_LIMIT, UPDATE_ONLINE_TRANSACTION_LIMIT, YBL_MODIFY_LIMITS_CONSTANTS, DEFAULT_ACTION } from './constants';
import { utils } from '../../devUtils';

const fetchCardDataSuccess = (payload) => ({ type: FETCH_CARD_DATA_YBL, payload });
const fetchOnlineTransactionLimitSuccess = (payload) => ({ type: FETCH_ONLINE_TRANSACTION_LIMIT, payload });
const updateOnlineTransactionLimitSuccess = (payload) => ({ type: UPDATE_ONLINE_TRANSACTION_LIMIT, payload });
const yblModifyLimitsOtpSuccess = (payload) => ({ type: YBL_MODIFY_LIMITS_CONSTANTS.YBL_UPDATE_LIMITS_OTP_SUCCESS, payload });
const yblSetChannelFlagSuccess = (payload) => ({ type: YBL_MODIFY_LIMITS_CONSTANTS.YBL_SET_CHANNEL_FLAG_SUCCESS, payload });

const fetchCardData = () => async (dispatch, getState, api) => {
  try {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION, true));
    dispatch(clearDefaultError());
    const authPrerequist = utils.getAuthPrerequist(getState, true);
    let res = null;
    res = await reqHandler.getHandler(api, endpoint.GET_WALLET_BALANCE_V3, {}, authPrerequist);
    if (res && res.status) {
      dispatch(fetchCardDataSuccess(res));
      return dispatch(utils.isReducerLoading(DEFAULT_ACTION));
    }
    throw (res.message);
  } catch (err) {
    dispatch(fetchCardDataSuccess({ status: false }));
    dispatch(rootApiResponse(errorResponse(DEFAULT_ACTION, err)));
    return dispatch(utils.isReducerLoading(DEFAULT_ACTION));
  }
};

const fetchOnlineTransactionLimit = () => async (dispatch, getState, api) => {
  try {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION, true));
    dispatch(clearDefaultError());
    const authPrerequist = utils.getAuthPrerequist(getState, true);
    let res = null;
    res = await reqHandler.getHandler(api, endpoint.GET_FETCH_ONLINE_TRANSACTION_LIMIT_V3, {}, authPrerequist);
    if (res && res.status) {
      return dispatch(fetchOnlineTransactionLimitSuccess(res));
    }
    throw (res.message);
  } catch (err) {
    dispatch(fetchOnlineTransactionLimitSuccess({ status: false }));
    return dispatch(rootApiResponse(errorResponse(DEFAULT_ACTION, err)));
  }
};

const updateOnlineTransactionLimit = (payload) => async (dispatch, getState, api) => {
  try {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION, true));
    dispatch(clearDefaultError());
    const authPrerequist = utils.getAuthPrerequist(getState, true);
    let res = null;
    res = await reqHandler.postHandler(api, endpoint.POST_UPDATE_ONLINE_TRANSACTION_LIMIT_V3, payload, authPrerequist);
    if (res && res.status) {
      dispatch(rootApiResponse(utils.successResponse(DEFAULT_ACTION, res.message)));
      await new Promise((resolve) => setTimeout(resolve, 2000));
      dispatch(updateOnlineTransactionLimitSuccess(res));
      return dispatch(utils.isReducerLoading(DEFAULT_ACTION));
    }
    throw (res.message);
  } catch (err) {
    dispatch(updateOnlineTransactionLimitSuccess({ status: false }));
    dispatch(utils.isReducerLoading(DEFAULT_ACTION));
    return dispatch(rootApiResponse(errorResponse(DEFAULT_ACTION, err)));
  }
};

const yblModifyLimitsOtp = (payload) => async (dispatch, getState, api) => {
  try {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION, true));
    dispatch(clearDefaultError());
    const authPrerequist = utils.getAuthPrerequist(getState, true);
    let response = null;
    response = await reqHandler.postHandler(api, endpoint.POST_YBL_MODIFY_LIMITS_OTP_V3, payload, authPrerequist);
    if (response && response.status) {
      dispatch(rootApiResponse(utils.successResponse(DEFAULT_ACTION, response.message)));
      await new Promise((resolve) => setTimeout(resolve, 2000));
      dispatch(yblModifyLimitsOtpSuccess(response));
      return dispatch(utils.isReducerLoading(DEFAULT_ACTION));
    }
    throw (response.message);
  } catch (err) {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION));
    return dispatch(rootApiResponse(errorResponse(DEFAULT_ACTION, err)));
  }
};

const SetChannelFlagYbl = (payload) => async (dispatch, getState, api) => {
  try {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION, true));
    dispatch(clearDefaultError());
    const authPrerequist = utils.getAuthPrerequist(getState, true);
    const response = await reqHandler.postHandler(api, endpoint.POST_CHANNEL_FLAG_V3, payload, authPrerequist);
    if (response && response.status) {
      return dispatch(yblSetChannelFlagSuccess(response));
    }
    throw response.message;
  } catch (err) {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION));
    return dispatch(rootApiResponse(errorResponse(DEFAULT_ACTION, err)));
  }
};

export {
  fetchCardData,
  fetchOnlineTransactionLimit,
  updateOnlineTransactionLimit,
  yblModifyLimitsOtp,
  SetChannelFlagYbl,
};



// WEBPACK FOOTER //
// client/containers/YesBankTransactionLimits/actions.js